import React, { useState } from 'react';
import {
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
  TextField,
  Box,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { selectStyle } from '../../static-data/configDropdownOptions';

const MultiSelectDropdown = ({
  options = [],
  selectedValues = [],
  maxSelections,
  placeholder = 'Select items',
  onChange,
  disabled = false,
  sx = {},
  menuProps = {},
  showSelectAll = true,
  searchable = false,
  name='records',
  multiple = true,
}) => {
  const [searchText, setSearchText] = useState('');

  const handleChange = (event) => {
    const value = event.target.value;
    if (multiple) {
      if (value.includes('all')) {
        onChange(selectedValues.length === options.length ? [] : options.map(option => option.id));
      } else {
        onChange(value);
      }
    } else {
      onChange(value);
    }
  };

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const filteredOptions = searchable
    ? options?.filter((option) =>
        option?.name?.toLowerCase().includes(searchText.toLowerCase())
      )
    : options;

  const renderValue = (selected) => {
    if (multiple) {
      if (selected.length === 0) return <span style={{ color: '#888' }}>{placeholder}</span>;
      if (selected.length === options.length && name === 'projects') {
        return 'All projects';
      }
      return selected
        .map((id) => {
          const selectedOption = options.find((option) => option.id === id);
          return selectedOption ? selectedOption.name : '';
        })
        .join(', ');
    } else {
      if (!selected) return <span style={{ color: '#888' }}>{placeholder}</span>;
      const selectedOption = options.find((option) => option.id === selected);
      return selectedOption ? selectedOption.name : <span style={{ color: '#888' }}>{placeholder}</span>;
    }
  };

  const isAllSelected = multiple && selectedValues.length === options.length;

  return (
    <FormControl sx={{ width: '100%', mb: 2, ...sx }} disabled={disabled}>
      <Select
        multiple={multiple}
        sx={selectStyle}
        IconComponent={KeyboardArrowDownIcon}
        value={selectedValues}
        onChange={handleChange}
        input={<OutlinedInput />}
        renderValue={renderValue}
        displayEmpty
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 250,
            },
          },
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
          autoFocus: false,
          ...menuProps,
        }}
        onClose={() => setSearchText('')}
      >
        {searchable && (
          <Box sx={{ px: 2, py: 1, position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1 }}>
            <TextField
              size="small"
              placeholder={`Search ${name}...`}
              fullWidth
              value={searchText}
              onChange={handleSearchChange}
              onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => e.stopPropagation()}
            />
          </Box>
        )}

        {multiple && showSelectAll && !searchText && options?.length > 1 && (
          <MenuItem value="all">
            <Checkbox checked={isAllSelected} />
            <ListItemText primary="Select All" />
          </MenuItem>
        )}
        {filteredOptions.length === 0 ? (
          <MenuItem disabled>
            <ListItemText primary={`No ${name} found`} sx={{ textAlign: 'center', color: 'text.secondary' }} />
          </MenuItem>
        ) : (
          filteredOptions?.map((option) => (
            <MenuItem
              key={option.id}
              value={option.id}
              disabled={
                multiple &&
                maxSelections !== undefined &&
                !selectedValues.includes(option.id) &&
                selectedValues.length >= maxSelections
              }
            >
              {multiple && (
                <Checkbox
                  checked={selectedValues.includes(option.id)}
                  disabled={
                    maxSelections !== undefined &&
                    !selectedValues.includes(option.id) &&
                    selectedValues.length >= maxSelections
                  }
                  disableRipple
                />
              )}
              <ListItemText
                primary={<span style={{ textTransform: 'none' }}>{option.name}</span>}
              />
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  );
};

export default MultiSelectDropdown;
